<div class="flex items-center justify-center min-h-screen">
  <div class="flex flex-col items-center space-y-4">
    <div class="animate-spin rounded-full h-12 w-12 border-b-2 border-black"></div>
    <p class="text-gray-600 text-sm">{{ message() }}</p>
  </div>
</div>
